import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'

import { ROUTES } from 'src/constants'
import { useStyles } from './styles'
import { joinAbsRoute } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'

const ImpactsLibraryNavButton = ({
  translation = 'impacts-library-header-title',
  navigation = ROUTES.IMPACTS_LIBRARY,
}) => {
  const navigate = useNavigate()
  const classes = useStyles()

  const handleClick = () => navigate(joinAbsRoute(navigation))

  return (
    <Button
      type="button"
      onClick={handleClick}
      variant="contained"
      color="secondary"
      className={`${classes.navigateButton} ${classes.buttonMb}`}
    >
      <HelperWrapper t={translation} ns={ETranslationNs.Navbar} />
    </Button>
  )
}

export { ImpactsLibraryNavButton }
